import React from 'react';
import { motion } from 'framer-motion';
import { SHOPIFY_URL } from './ui/CTAButton';
import { ProductImage } from './ui/ProductImage';
const BONUSES = [{
  id: 1,
  title: 'Guía de Juegos Lectores',
  desc: '+20 juegos y dinámicas para practicar en familia (sin aburrimiento).',
  image: 'https://cdn.magicpatterns.com/uploads/7Wh2XjHUrf2oxUMzyNYhtT/2.png'
}, {
  id: 2,
  title: 'Kit de Ejercicios Imprimibles',
  desc: '+50 hojas listas para imprimir y practicar semanalmente.',
  image: 'https://cdn.magicpatterns.com/uploads/gELaHEwgdJey6U1epBAFWp/3.png'
}, {
  id: 3,
  title: 'Biblioteca de Audiocuentos Educativos',
  desc: '+20 audiocuentos para estimular imaginación y comprensión auditiva.',
  image: 'https://cdn.magicpatterns.com/uploads/7WEBuzLquCBJjA58w3cSW3/4.png'
}, {
  id: 4,
  title: 'Pack Silábico Completo',
  desc: 'Cartillas + tarjetas interactivas + ejercicios progresivos para acelerar fluidez.',
  image: 'https://cdn.magicpatterns.com/uploads/hzgnSScLufFK58DkM4YDzz/5.png'
}, {
  id: 5,
  title: 'Lecturas con Imágenes (Edición Especial)',
  desc: 'Lecturas cortas con imágenes llamativas + actividades simples de comprensión.',
  image: 'https://cdn.magicpatterns.com/uploads/5VPd92vT226MohMfhXDkd4/6.png'
}];
export function BonusSection() {
  return <section className="py-20 px-4 bg-[#F5F0FF]" data-id="element-55">
      <div className="max-w-6xl mx-auto" data-id="element-56">
        <div className="text-center mb-16" data-id="element-57">
          <h2 className="text-4xl md:text-6xl font-black text-gray-900 mb-4 uppercase tracking-tight" data-id="element-58">
            🎁 REGALOS ESPECIALES
          </h2>
          <p className="text-2xl font-bold text-purple-700 bg-purple-100 inline-block px-6 py-2 rounded-full" data-id="element-59">
            (INCLUIDOS HOY GRATIS)
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-60">
          {BONUSES.map((bonus, index) => <motion.div key={bonus.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-3xl p-6 shadow-xl border-2 border-purple-100 flex flex-col h-full" data-id="element-61">
              <div className="mb-6" data-id="element-62">
                <a href={SHOPIFY_URL} className="block" data-id="element-63">
                  <motion.img src={bonus.image} alt={bonus.title} className="w-full aspect-square object-cover rounded-2xl shadow-lg border-2 border-white cursor-pointer" whileHover={{
                scale: 1.03
              }} data-id="element-64" />
                </a>
              </div>
              <div className="text-center flex-grow flex flex-col justify-between" data-id="element-65">
                <div data-id="element-66">
                  <h3 className="text-xl font-black text-gray-900 mb-3 text-center" data-id="element-67">
                    🎁 Bono #{bonus.id} — {bonus.title}
                  </h3>
                  <p className="text-gray-600 font-medium mb-4" data-id="element-68">{bonus.desc}</p>
                </div>
                <motion.div animate={{
              scale: [1, 1.08, 1],
              boxShadow: ['0 0 0px rgba(34, 197, 94, 0)', '0 0 20px rgba(34, 197, 94, 0.6)', '0 0 0px rgba(34, 197, 94, 0)']
            }} transition={{
              duration: 2,
              repeat: Infinity,
              ease: 'easeInOut'
            }} className="bg-green-500 text-white font-black py-3 px-4 rounded-xl uppercase text-lg tracking-wider" data-id="element-69">
                  🎉 HOY: GRATIS
                </motion.div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}